import { createContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const STORAGE_THEMEMODE = 'theme';

function ThemeProvider({ children }) {
	const getInitialTheme = () => {
		const storedTheme = localStorage.getItem(STORAGE_THEMEMODE);
		if (storedTheme) {
			return storedTheme;
		} else {
			const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
			return prefersDark ? 'dark' : 'light';
		}
	};

	const [theme, setTheme] = useState(getInitialTheme);

	useEffect(() => {
		localStorage.setItem(STORAGE_THEMEMODE, theme);
	}, [theme]);

	// To toggle between dark and light modes
	const toggleTheme = () => {
		setTheme(theme === 'dark' ? 'light' : 'dark');
	};

	return (
		<ThemeContext.Provider value={{ currentTheme: theme, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
}

export { ThemeProvider, ThemeContext };
